module.exports = __webpack_public_path__ + "static/media/Deposit.15c48b1f.svg";